// src/services/auth-headerService.js
export function authHeader() {
  const token = localStorage.getItem("token");

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
}
